import { useWatch } from 'react-hook-form';
import { SelectField } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { CancellationPolicyApplicability } from '@mews-commander/data-access';
import { Option } from '@mews-commander/types';
import { CancellationPolicyFormField, CancellationPolicyOffsetType } from '../../types';

export const OffsetTypeSelectField = () => {
    const applicability = useWatch({ name: CancellationPolicyFormField.Applicability });
    return (
        <SelectField
            name={CancellationPolicyFormField.OffsetType}
            options={offsetTypeOptions}
            showEmptyValue={false}
            required
            disabled={applicability === CancellationPolicyApplicability.Creation}
        />
    );
};

const offsetTypeOptions: Option[] = [
    createOption({
        value: CancellationPolicyOffsetType.Before,
        label: lt('CancellationPolicyOffsetTypeBefore'),
    }),
    createOption({
        value: CancellationPolicyOffsetType.After,
        label: lt('CancellationPolicyOffsetTypeAfter'),
    }),
];
